module.exports = __webpack_public_path__ + "img/Implemented.f067519b.png";